<div class="priority-order-dialog">
    <div class="config-warning">
        <span class="k-icon k-i-warning"></span>
        <div>
            <strong>Drag to change which rule wins when two rules overlap.</strong>
            <p>
                This order is global across every market, not just within one - the rule
                nearest the top wins whenever two overlapping rules would otherwise both match.
            </p>
        </div>
    </div>

    <div class="priority-list" cdkDropList (cdkDropListDropped)="onDrop($event.previousIndex, $event.currentIndex)">
        <div class="priority-row" *ngFor="let row of rows; let i = index" cdkDrag>
            <span class="drag-handle" cdkDragHandle><i class="fas fa-grip-vertical"></i></span>
            <span class="priority-rank">{{ i + 1 }}</span>
            <span class="priority-service mono">{{ row.service }}</span>
            <span class="priority-market">{{ row.marketName }}</span>
            <span class="priority-days">{{ row.days ? row.days.join(', ') : 'All days' }}</span>
            <span class="priority-dates" *ngIf="row.dateFrom">{{ row.dateFrom }} &ndash; {{ row.dateTo }}</span>
            <span class="priority-overlap" *ngIf="row.overlapCount" title="Resolved by this priority order">
                <i class="fas fa-exclamation-triangle"></i>
                overlaps {{ row.overlapCount }} other rule{{ row.overlapCount === 1 ? '' : 's' }}
            </span>
        </div>
    </div>

    <kendo-dialog-actions [layout]="'normal'">
        <button kendoButton (click)="onCancel()">Cancel</button>
        <button kendoButton [primary]="true" (click)="onApply()">Apply</button>
    </kendo-dialog-actions>
</div>
